import { BASE_URL } from "../config";
import { axiosInstance } from "../providers/AxiosProvider";

export function importData(formData) {
  return axiosInstance.post(`${BASE_URL}/api/students/import`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

export function exportData() {
  return axiosInstance.get(`${BASE_URL}/api/students/export`, {
    headers: {
      "Content-Type": "application/json",
    },
    responseType: "blob",
  });
}

export function exportOneGroup(groupId) {
  return axiosInstance.get(`${BASE_URL}/api/groups/${groupId}/export`, {
    headers: {
      "Content-Type": "application/json",
    },
    responseType: "blob",
  });
}
